import { useLayoutEffect } from 'react'
import { useLocation } from 'react-router-dom'

const useScrollToTop = (trigger?: unknown) => {
  const { pathname } = useLocation()

  // scroll to top when pathname changes or when the optional trigger changes
  useLayoutEffect(() => {
    document.documentElement.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant',
    })
  }, [pathname, trigger])
}

export default useScrollToTop
